import React, { memo } from 'react'
import { TooltipPositionTypes } from '../../libraries/Tooltips'
import './IconButtonWithLabel.scss'
const rootClassName = 'icon-button-with-label'

interface IconButtonWithLabelProps {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  label?: string
  value?: string
  iconButton?: React.ReactNode
}

function IconButtonWithLabel(props: IconButtonWithLabelProps) {
  return (
    <div className={rootClassName}>
      <div className={`${rootClassName}-icon`}>{props.iconButton}</div>
      <div className={`${rootClassName}-label`}>{props.label}</div>
      <div className={`${rootClassName}-value`}>{props.value}</div>
    </div>
  )
}

IconButtonWithLabel.defaultProps = {}

export default memo(IconButtonWithLabel)
